export default "__VITE_ASSET__b09c9bae__"